module.exports = __webpack_public_path__ + "img/MGH-Gion-2.c6de2a24.jpg";